import moment from "moment";
import { GetAccount200Response } from "../../codegen-api";
import { nanosToSeconds } from "../../utils/date";

export const normalizeAccountData = (accountData: GetAccount200Response) => ({
  ...accountData,
  positions: (accountData.positions || []).sort((a, b) => {
    if (a.option && b.option) {
      if (a.option.expiry === b.option.expiry) {
        return Number(b.amount) - Number(a.amount);
      }
      return (
        moment.unix(nanosToSeconds(a.option.expiry)).toDate().getTime() -
        moment.unix(nanosToSeconds(b.option.expiry)).toDate().getTime()
      );
    }
    return a.instrument_name.localeCompare(b.instrument_name);
  }),
});

export const isAccountSnapshot = (data: any): data is GetAccount200Response =>
  !!data &&
  typeof data === "object" &&
  !data.action &&
  (Array.isArray(data.positions) || data.account_value !== undefined);
